import React from 'react';
import { AnswerStats } from 'src/redux/survey/survey.types';

interface QuestionAnswerProps {
  answer: AnswerStats;
  handleAnswerClick: (answerId: string) => void;
}

const QuestionAnswer: React.FC<QuestionAnswerProps> = ({ answer, handleAnswerClick }) => {
  return (
    <div className="flex items-center justify-between px-3">
      <div
        onClick={() => handleAnswerClick(answer.id)}
        className="w-full h-16 bg-gray-600 rounded-2xl relative cursor-pointer transition-all duration-300 hover:opacity-80"
      >
        <div
          className="h-full bg-blue-500 rounded-xl"
          style={{ width: `${answer.totalPercentage}%` }}
        />
        <span className="bg-gray-500/80 px-2 rounded-full text-white text-sm absolute right-3 top-1/2 -translate-y-1/2 transform text-right">
          {answer.totalPercentage.toFixed(0)}
          %
          (
          {answer.totalUsers}
          )
        </span>
        <span className="text-white text-sm absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-center">
          {answer.title}
        </span>
      </div>
    </div>
  );
};

export default QuestionAnswer;
